import React from 'react';
import { FormControl } from 'react-bootstrap';

export const GenderSelect = props => (
  <FormControl
    {...props}
    componentClass="select"
  >
    <option />
    <option>Female</option>
    <option>Male</option>
    <option>Nonbinary</option>
  </FormControl>
);
